import script from "./pay-info-confirm-next.vue?vue&type=script&lang=tsx&setup=true"
export * from "./pay-info-confirm-next.vue?vue&type=script&lang=tsx&setup=true"

import "./pay-info-confirm-next.vue?vue&type=style&index=0&id=7218ce08&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7218ce08"]])

export default __exports__